import React from "react";

import "./GradientBorder.css";

const GradientBorder = () => {
	return <div className="gradient-border"></div>;
};

export default GradientBorder;
